/* eslint-disable import/no-named-as-default-member */
import _ from "lodash";
import React, { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import styled from "styled-components";
import { Dialog, DialogContent, DialogTitle, DialogActions, Grid, InputLabel } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import CheckIcon from '@material-ui/icons/Check';
import SecondaryButton from 'components/Global/Buttons/SecondaryButton';
import { getSupCalcInfo, saveSupplementalCalcSettings } from "store/state/companies";
import { getConfigItemByParentId } from 'store/state/configItems';
import { VersitileInput } from "components/Global/Fields/VersitileInput";
import TypeAheadDropdown from "components/Global/Fields/TypeAheadDropdown";
import { ToastSuccess } from "components/Global/Toasts/Toasty";
import calcConfigItems from "constants/calculationConfigItems";
import FLOATING_INDICES_CONSTANTS from "constants/floatingIndexes";
import { FLOATING_INDICES, FIXED_INDICES } from "constants/configItemParents";
import { setConfigItemListState } from "components/Global/Fields/util";
import { StyledDialogIconButton } from "components/Deal/CalculatorDialogs/styles";

const CustomLabelForDropDown = (props) => (
    <InputLabel
        htmlFor={props.htmlFor}
        style={{ fontSize: "15px", color: "#999999" }}>
        <div style={{ marginTop: "-2px" }}>{props.text}</div>
    </InputLabel>
);


const PageContainer = styled.div`
    margin-left: 20px;
`;

const TitleBar = styled.div`
  && {
    font-size: 24px;
    marign-top: 25px;
    margin-bottom: 25px;
  }
`;

const TableTitleBar = styled.div`
  && {
    font-size: 18px;
    marign-top: 25px;
    margin-bottom: 15px;
    color: #aaaaaa;
  }
`;

const PrettyTable = styled.table`
border-spacing: 0px;
`

const GreyHeader = styled.tr`
background-color: #f9f9f9;
color: black
`

const HeaderCell = styled.th`
&& {
    border-bottom: 3px solid #eeeeee;
    font-weight: normal;
    font-size: 18;
    width: 100px;
    text-align: center;
}
`
const UpperHeaderCell = styled.th`
&& {
    border-bottom: 1px solid #aaaaaa;
    font-weight: bold;
    font-size: 18;
    text-align: center;
}
`


const UniformCell = styled.td`
    width: 100px !important;
    border-bottom: 1px solid #eeeeee;
    padding-top: 5px;
    padding-bottom: 5px;
    text-align: center;
`;
const selectStyles = {
    container: (provided) => (
        {
            ...provided,
            borderBottom: '1px solid #949494',
            transition: 'border 0.1s',
            '&:hover': {
                cursor: 'pointer',
                borderBottom: '2px solid'
            },
            padding: '0',
            width: '183px'
        }),
}
class SupCalculatorSettingsPage extends Component {
    state = {
        calculationConfigItems: {},
        creditGuidanceValues: null,
        tiers: null,
        tierValues: null,
        isTierModalOpen: false,
        proposedTiers: null,
        floatingIndices: [],
        fixedIndices: [],
    }

    componentDidMount() {
        this.props.getSupCalcInfo();
        this.props.getConfigItemByParentId({ id: FLOATING_INDICES });
        this.props.getConfigItemByParentId({ id: FIXED_INDICES });
    }

    componentDidUpdate = (prevProps, prevState) => {
        const { floatingIndices: prevFloatingIndices } = prevState;
        if (!prevProps.calculationConfigItems && this.props.calculationConfigItems) {
            this.setState({ calculationConfigItems: this.convertCalculationConfigItems(this.props.calculationConfigItems, true) })
        }
        if (!prevProps.creditGuidanceValues && this.props.creditGuidanceValues) {
            this.setState({ creditGuidanceValues: this.convertCreditGuidancePercentages(this.props.creditGuidanceValues, true) });
        }
        if (!prevProps.tiers && this.props.tiers) {
            this.setState({ tiers: this.convertTiers(this.props.tiers) });
            this.setState({ proposedTiers: this.convertTiers(this.props.tiers) })
        }
        if (!prevProps.tierValues && this.props.tierValues) {
            this.setState({ tierValues: this.convertTierValues(this.props.tierValues, true) });
        }
        if (this.props.configItems && this.props.configItems.configItemByParent) {
            setConfigItemListState(FIXED_INDICES, "fixedIndices", this);
        }
        if (this.props.configItems?.configItemByParent?.[FLOATING_INDICES] && prevFloatingIndices.length === 0) {
            const configFloatingIndices = this.props.configItems.configItemByParent[FLOATING_INDICES].map(fi => ({
                value: fi.id,
                label: fi.name
            }));
            const primeItem = configFloatingIndices.find(fi => fi.value === FLOATING_INDICES_CONSTANTS.PRIME);
            this.setState({ floatingIndices: [...configFloatingIndices.filter(fi => fi.value !== FLOATING_INDICES_CONSTANTS.PRIME), primeItem] });
        }
    }

    convertCalculationConfigItems = (items, shouldScaleUpPercents) => {
        let out = {};
        items.forEach(item => {
            if (shouldScaleUpPercents && (item.id === calcConfigItems.FIRST_SUPP_RISK_SPREAD || item.id === calcConfigItems.ADDITIONAL_SUPP_RISK_SPREAD)) {
                item.value *= 100;
            }

            if (item.id === calcConfigItems.FLOATING_RATE_DEFAULT_INDEX || item.id === calcConfigItems.FIXED_RATE_DEFAULT_INDEX) {
                out[item.id] = item.optionId;
            } else {
                out[item.id] = item.value;
            }
        });
        return out;
    }

    convertTiers = (tiersObj) => {
        let out = _.cloneDeep(tiersObj);
        out.forEach(x => {
            if (x.LTV) {
                x.LTV *= 100;
            }
        })
        return out;
    }

    convertTierValues = (tierValueObject, shouldScaleUpPercents) => {
        if (shouldScaleUpPercents) {
            tierValueObject.forEach(x => {
                if (x.value) x.value *= 100;
            })
        }
        let out = _.cloneDeep(tierValueObject);
        return this.getTierValueRows(out);
    }

    convertCreditGuidancePercentages = (creditGuidanceObject, shouldScaleUpPercents) => {
        if (shouldScaleUpPercents) {
            creditGuidanceObject.forEach(row => {
                row.amortLTV *= 100;
                row.partialIoLTV *= 100;
                row.fullIoLTV *= 100;
            });
        }
        return _.cloneDeep(creditGuidanceObject);
    }

    render() {
        return (
            <PageContainer>
                <TitleBar>
                    SUPPLEMENTAL CALCULATOR SETTINGS
                    <SecondaryButton onClick={this.cancelChanges}><CloseIcon />Cancel</SecondaryButton>
                    <SecondaryButton onClick={this.saveChanges}><CheckIcon />Save</SecondaryButton>
                </TitleBar>
                {this.renderConfigItemSection()}
                <TableTitleBar>CREDIT GUIDANCE</TableTitleBar>
                {this.renderCreditGuidanceSection()}
                <TableTitleBar>WEEKLY PRICING COLOR</TableTitleBar>
                {this.renderTierTable()}
                {this.renderTierModal()}
            </PageContainer>
        )
    }

    saveChanges = () => {
        for (const item of this.props.calculationConfigItems) {
            if (item.id === calcConfigItems.FLOATING_RATE_DEFAULT_INDEX || item.id === calcConfigItems.FIXED_RATE_DEFAULT_INDEX) {
                item.optionId = this.state.calculationConfigItems[item.id];
            } else {
                item.value = this.state.calculationConfigItems[item.id];
            }
        }

        this.state.creditGuidanceValues.forEach(record => {
            let toChange = this.props.creditGuidanceValues.filter(x => x.id === record.id)[0];
            toChange.maxTerm = record.maxTerm;
            toChange.minTerm = record.minTerm;
            toChange.amortDSCR = record.amortDSCR;
            toChange.amortLTV = record.amortLTV;
            toChange.partialIoDSCR = record.partialIoDSCR;
            toChange.partialIoLTV = record.partialIoLTV;
            toChange.fullIoDSCR = record.fullIoDSCR;
            toChange.fullIoLTV = record.fullIoLTV;
        });
        this.state.tierValues.forEach(row => {
            row.ids.forEach(rowId => {
                let record = this.props.tierValues.filter(x => x.id === rowId)[0];
                record.value = row[`tier${record.tier}Value`];
                record.maxTerm = row.maxTerm;
                record.minTerm = row.minTerm;
            })
        })
        this.props.saveSupplementalCalcSettings(this.props);
    }

    saveProposedTiers = () => {
        this.props.saveSupplementalCalcSettings({ tiers: this.state.proposedTiers, savingTiers: true })
        this.state.proposedTiers.forEach(proposition => {
            let record = this.state.tiers.filter(x => x.tier === proposition.tier)[0];
            record.DSCR = proposition.DSCR;
            record.LTV = proposition.LTV;
        });
        this.setState({ isTierModalOpen: false });
    }

    cancelChanges = () => {
        this.setState({ calculationConfigItems: this.convertCalculationConfigItems(this.props.calculationConfigItems) });
        this.setState({ creditGuidanceValues: this.convertCreditGuidancePercentages(this.props.creditGuidanceValues) });
        this.setState({ tierValues: this.convertTierValues(this.props.tierValues) });
        ToastSuccess("Changes Canceled")
    }

    renderCreditGuidanceSection = () => {
        return (
            <PrettyTable style={{ marginBottom: "60px" }}>
                <GreyHeader>
                    <UpperHeaderCell colSpan={2}>Term (m)</UpperHeaderCell>
                    <UpperHeaderCell colSpan={2}>Amort</UpperHeaderCell>
                    <UpperHeaderCell colSpan={2}>Partial IO</UpperHeaderCell>
                    <UpperHeaderCell colSpan={2}>Full IO</UpperHeaderCell>
                </GreyHeader>
                <GreyHeader>
                    <HeaderCell>Max</HeaderCell>
                    <HeaderCell>Min</HeaderCell>
                    <HeaderCell>DSCR</HeaderCell>
                    <HeaderCell>LTV</HeaderCell>
                    <HeaderCell>DSCR</HeaderCell>
                    <HeaderCell>LTV</HeaderCell>
                    <HeaderCell>DSCR</HeaderCell>
                    <HeaderCell>LTV</HeaderCell>
                </GreyHeader>
                {this.renderCreditGuidanceRows()}
            </PrettyTable>
        )
    }

    renderCreditGuidanceRows = () => {
        if (!this.state.creditGuidanceValues) return null;
        let values = _.orderBy(this.state.creditGuidanceValues, "sortOrder", "asc");
        let out = [];
        const inputStyle = { maxWidth: "80px" }

        values.forEach(record => {
            out.push(<tr>
                <UniformCell>
                    <VersitileInput
                        type={"integer"}
                        style={inputStyle}
                        value={record.maxTerm}
                        onChange={value => {
                            this.setCreditGuidanceValue(record, "maxTerm", value);
                        }}
                    />
                </UniformCell>
                <UniformCell>
                    <VersitileInput
                        type={"integer"}
                        style={inputStyle}
                        value={record.minTerm}
                        onChange={value => {
                            this.setCreditGuidanceValue(record, "minTerm", value);
                        }}
                    />
                </UniformCell>
                <UniformCell>
                    <VersitileInput
                        type={"dscr"}
                        style={inputStyle}
                        value={record.amortDSCR ? record.amortDSCR.toFixed(2) : null}
                        onChange={value => {
                            this.setCreditGuidanceValue(record, "amortDSCR", value);
                        }}
                    />
                </UniformCell>
                <UniformCell>
                    <VersitileInput
                        type={"percent"}
                        style={inputStyle}
                        value={record.amortLTV ? record.amortLTV.toFixed(2) : null}
                        onChange={value => {
                            this.setCreditGuidanceValue(record, "amortLTV", value);
                        }}
                    />
                </UniformCell>
                <UniformCell>
                    <VersitileInput
                        type={"dscr"}
                        style={inputStyle}
                        value={record.partialIoDSCR ? record.partialIoDSCR.toFixed(2) : null}
                        onChange={value => {
                            this.setCreditGuidanceValue(record, "partialIoDSCR", value);
                        }}
                    />
                </UniformCell>
                <UniformCell>
                    <VersitileInput
                        type={"percent"}
                        style={inputStyle}
                        value={record.partialIoLTV ? record.partialIoLTV.toFixed(2) : null}
                        onChange={value => {
                            this.setCreditGuidanceValue(record, "partialIoLTV", value);
                        }}
                    />
                </UniformCell>
                <UniformCell>
                    <VersitileInput
                        type={"dscr"}
                        style={inputStyle}
                        value={record.fullIoDSCR ? record.fullIoDSCR.toFixed(2) : null}
                        onChange={value => {
                            this.setCreditGuidanceValue(record, "fullIoDSCR", value);
                        }}
                    />
                </UniformCell>
                <UniformCell>
                    <VersitileInput
                        type={"percent"}
                        style={inputStyle}
                        value={record.fullIoLTV ? record.fullIoLTV.toFixed(2) : null}
                        onChange={value => {
                            this.setCreditGuidanceValue(record, "fullIoLTV", value);
                        }}
                    />
                </UniformCell>
            </tr>)
        })
        return out;
    }


    renderTierTable = () => {
        if (!this.state.tiers) return null;
        return (
            <>
                <SecondaryButton onClick={() => this.setState({ isTierModalOpen: true })}>Edit Tier Values</SecondaryButton>
                <PrettyTable style={{ marginBottom: "40px" }}>
                    <GreyHeader>
                        <td colSpan={2}></td>
                        <UpperHeaderCell colSpan={2}>Tier 1</UpperHeaderCell>
                        <UpperHeaderCell colSpan={2}>Tier 2</UpperHeaderCell>
                        <UpperHeaderCell colSpan={2}>Tier 3</UpperHeaderCell>
                    </GreyHeader>
                    <GreyHeader>
                        <UpperHeaderCell colSpan={2}>Term (m)</UpperHeaderCell>
                        <UpperHeaderCell>DSCR</UpperHeaderCell>
                        <UpperHeaderCell>LTV</UpperHeaderCell>
                        <UpperHeaderCell>DSCR</UpperHeaderCell>
                        <UpperHeaderCell>LTV</UpperHeaderCell>
                        <UpperHeaderCell>DSCR</UpperHeaderCell>
                        <UpperHeaderCell>LTV</UpperHeaderCell>
                    </GreyHeader>
                    <GreyHeader>
                        <HeaderCell>Max</HeaderCell>
                        <HeaderCell>Min</HeaderCell>
                        <HeaderCell>{this.state.tiers.filter(x => x.tier === 1)[0].DSCR || "-"}x</HeaderCell>
                        <HeaderCell>{this.state.tiers.filter(x => x.tier === 1)[0].LTV || "-"}%</HeaderCell>
                        <HeaderCell>{this.state.tiers.filter(x => x.tier === 2)[0].DSCR || "-"}x</HeaderCell>
                        <HeaderCell>{this.state.tiers.filter(x => x.tier === 2)[0].LTV || "-"}%</HeaderCell>
                        <HeaderCell>{this.state.tiers.filter(x => x.tier === 3)[0].DSCR || "-"}x</HeaderCell>
                        <HeaderCell>{this.state.tiers.filter(x => x.tier === 3)[0].LTV || "-"}%</HeaderCell>
                    </GreyHeader>
                    {this.renderTierRows()}
                </PrettyTable>
            </>
        )
    }

    getTierValueRows = (tierValues) => {
        let values = _.orderBy(tierValues, "sortOrder", "asc");
        let out = [];
        for (let i = 0; i < tierValues.length; i += 3) {
            let record = {};
            record.maxTerm = values[i].maxTerm;
            record.minTerm = values[i].minTerm;
            record.tier1Value = values[i].value;
            record.tier2Value = values[i + 1].value;
            record.tier3Value = values[i + 2].value;
            record.ids = [values[i].id, values[i + 1].id, values[i + 2].id];
            out.push(record);
        }
        return out;
    }

    renderTierRows = () => {
        if (!this.state.tierValues) return null;
        let inputStyle = { maxWidth: '80px' }
        let out = [];
        let values = this.state.tierValues;
        values.forEach(record => {
            out.push(<tr>
                <UniformCell>
                    <VersitileInput
                        type={"integer"}
                        style={inputStyle}
                        value={record.maxTerm}
                        onChange={(value) => {
                            this.setTierTableValue(record, "maxTerm", value);
                        }}
                    />
                </UniformCell>
                <UniformCell>
                    <VersitileInput
                        type={"integer"}
                        style={inputStyle}
                        value={record.minTerm}
                        onChange={(value) => {
                            this.setTierTableValue(record, "minTerm", value);
                        }}
                    />
                </UniformCell>
                <UniformCell colSpan={2}>
                    <VersitileInput
                        type={"percent"}
                        style={inputStyle}
                        value={record.tier1Value ? record.tier1Value.toFixed(2) : null}
                        onChange={(value) => {
                            this.setTierTableValue(record, "tier1Value", value);
                        }}
                    />
                </UniformCell>
                <UniformCell colSpan={2}>
                    <VersitileInput
                        type={"percent"}
                        style={inputStyle}
                        value={record.tier2Value ? record.tier2Value.toFixed(2) : null}
                        onChange={(value) => {
                            this.setTierTableValue(record, "tier2Value", value);
                        }}
                    />
                </UniformCell>
                <UniformCell colSpan={2}>
                    <VersitileInput
                        type={"percent"}
                        style={inputStyle}
                        value={record.tier3Value ? record.tier3Value.toFixed(2) : null}
                        onChange={(value) => {
                            this.setTierTableValue(record, "tier3Value", value);
                        }}
                    />
                </UniformCell>
            </tr>)
        });
        return out;
    }

    setTierTableValue = (record, fieldName, newValue) => {
        let newObj = this.state.tierValues;
        newObj.filter(x => record.ids.includes(x.ids[0]))[0][fieldName] = newValue;
        this.setState({ tierValues: newObj });
    }

    setCreditGuidanceValue = (record, fieldName, newValue) => {
        let newObj = this.state.creditGuidanceValues;
        newObj.filter(x => x.id === record.id)[0][fieldName] = newValue;
        this.setState({ creditGuidanceValues: newObj });
    }

    renderConfigItemSection = () => {
        if (!this.props.calculationConfigItems) return null;
        const { floatingIndices, fixedIndices } = this.state;

        const INPUT_STYLE = { marginRight: "50px", marginBottom: "15px", maxWidth: "550px" };
        return (
            <Grid container >
                <Grid container item sm={6} md={6} >
                    <Grid item sm={4} md={4}>
                        <VersitileInput
                            type="money"
                            style={INPUT_STYLE}
                            internalLabel="Supplemental Min Field"
                            value={this.state.calculationConfigItems[calcConfigItems.SUPPLEMENTAL_MIN_FIELD]}
                            onChange={(value) => {
                                let newObj = this.state.calculationConfigItems;
                                newObj[calcConfigItems.SUPPLEMENTAL_MIN_FIELD] = value;
                                this.setState({ calculationConfigItems: newObj });
                            }}
                        />
                    </Grid>

                    <Grid item sm={4} md={4}>
                        <VersitileInput
                            type="integer"
                            style={INPUT_STYLE}
                            internalLabel="Amortization Term (m)"
                            value={this.state.calculationConfigItems[calcConfigItems.AMORTIZATION_TERM]}
                            onChange={(value) => {
                                let newObj = this.state.calculationConfigItems;
                                newObj[calcConfigItems.AMORTIZATION_TERM] = value;
                                this.setState({ calculationConfigItems: newObj });
                            }}
                        />
                    </Grid>

                    <Grid item sm={4} md={4}>
                        <TypeAheadDropdown
                            name="floatingRateDefaultIndexId"
                            selectStyles={selectStyles}
                            label="Floating Rate Default Index"
                            placeholder="Floating Rate Default Index"
                            customLabel={(<CustomLabelForDropDown htmlFor="floatingRateDefaultIndexId" text="Floating Rate Default Index" />)}
                            value={this.state.calculationConfigItems[calcConfigItems.FLOATING_RATE_DEFAULT_INDEX]}
                            options={floatingIndices}
                            handleChange={(selectedItem) => {
                                let newObj = this.state.calculationConfigItems;
                                newObj[calcConfigItems.FLOATING_RATE_DEFAULT_INDEX] = selectedItem.value;
                                this.setState({ calculationConfigItems: newObj });
                            }}
                            shouldShow={true}
                            usingFormik={false}
                        />
                    </Grid>

                    <Grid item sm={4} md={4}>
                        <VersitileInput
                            type="percent"
                            style={INPUT_STYLE}
                            internalLabel="First Supp Risk Spread"
                            value={this.state.calculationConfigItems[calcConfigItems.FIRST_SUPP_RISK_SPREAD]}
                            onChange={(value) => {
                                let newObj = this.state.calculationConfigItems;
                                newObj[calcConfigItems.FIRST_SUPP_RISK_SPREAD] = value;
                                this.setState({ calculationConfigItems: newObj });
                            }}
                        />
                    </Grid>

                    <Grid item sm={4} md={4}>
                        <VersitileInput
                            type="percent"
                            style={INPUT_STYLE}
                            internalLabel="Additional Supp Risk Spread"
                            value={this.state.calculationConfigItems[calcConfigItems.ADDITIONAL_SUPP_RISK_SPREAD]}
                            onChange={(value) => {
                                let newObj = this.state.calculationConfigItems;
                                newObj[calcConfigItems.ADDITIONAL_SUPP_RISK_SPREAD] = value;
                                this.setState({ calculationConfigItems: newObj });
                            }}
                        />
                    </Grid>

                    <Grid item sm={4} md={4}>
                        <TypeAheadDropdown
                            name="fixedRateDefaultIndexId"
                            selectStyles={selectStyles}
                            label="Fixed Rate Default Index"
                            customLabel={(<CustomLabelForDropDown htmlFor="fixedRateDefaultIndexId" text="Fixed Rate Default Index" />)}
                            placeholder="Fixed Rate Default Index"
                            value={this.state.calculationConfigItems[calcConfigItems.FIXED_RATE_DEFAULT_INDEX]}
                            options={fixedIndices}
                            handleChange={(selectedItem) => {
                                let newObj = this.state.calculationConfigItems;
                                newObj[calcConfigItems.FIXED_RATE_DEFAULT_INDEX] = selectedItem.value;
                                this.setState({ calculationConfigItems: newObj });
                            }}
                            shouldShow={true}
                            usingFormik={false}
                        />
                    </Grid>
                </Grid>

            </Grid>
        );
    }

    closeModal = () => {
        this.setState({ proposedTiers: this.convertTiers(this.props.tiers) });
        this.setState({ isTierModalOpen: false })
    }

    renderTierModal = () => {
        if (!this.state.proposedTiers) return null;
        let inputStyle = { marginRight: "50px", marginBottom: "50px" }
        return (
            <Dialog maxWidth={"md"} open={this.state.isTierModalOpen}>
                <DialogTitle>Edit Tier Info</DialogTitle>
                <DialogContent style={{ width: "500px" }}>
                    <StyledDialogIconButton onClick={this.closeModal}><CloseIcon /></StyledDialogIconButton>
                    <div>
                        <VersitileInput
                            internalLabel={"Tier 1 DSCR"}
                            type="dscr"
                            style={inputStyle}
                            value={this.state.proposedTiers.filter(x => x.tier === 1)[0].DSCR}
                            onChange={value => {
                                this.updateProposedTierValue(1, "DSCR", value);
                            }}
                        />
                        <VersitileInput
                            internalLabel={"Tier 1 LTV"}
                            type="percent"
                            style={inputStyle}
                            value={this.state.proposedTiers.filter(x => x.tier === 1)[0].LTV}
                            onChange={value => {
                                this.updateProposedTierValue(1, "LTV", value);
                            }}
                        />
                    </div>
                    <div>
                        <VersitileInput
                            internalLabel={"Tier 2 DSCR"}
                            type="dscr"
                            style={inputStyle}
                            value={this.state.proposedTiers.filter(x => x.tier === 2)[0].DSCR}
                            onChange={value => {
                                this.updateProposedTierValue(2, "DSCR", value);
                            }}
                        />
                        <VersitileInput
                            internalLabel={"Tier 2 LTV"}
                            type="percent"
                            style={inputStyle}
                            value={this.state.proposedTiers.filter(x => x.tier === 2)[0].LTV}
                            onChange={value => {
                                this.updateProposedTierValue(2, "LTV", value);
                            }}
                        />
                    </div>
                    <div>
                        <VersitileInput
                            internalLabel={"Tier 3 DSCR"}
                            type="dscr"
                            style={inputStyle}
                            value={this.state.proposedTiers.filter(x => x.tier === 3)[0].DSCR}
                            onChange={value => {
                                this.updateProposedTierValue(3, "DSCR", value);
                            }}
                        />
                        <VersitileInput
                            internalLabel={"Tier 3 LTV"}
                            type="percent"
                            style={inputStyle}
                            value={this.state.proposedTiers.filter(x => x.tier === 3)[0].LTV}
                            onChange={value => {
                                this.updateProposedTierValue(3, "LTV", value);
                            }}
                        />
                    </div>
                </DialogContent>
                <DialogActions>
                    <SecondaryButton onClick={this.closeModal}>Cancel</SecondaryButton>
                    <SecondaryButton onClick={this.saveProposedTiers}>Save</SecondaryButton>
                </DialogActions>
            </Dialog>
        )
    }

    updateProposedTierValue = (tier, fieldName, value) => {
        let newObj = this.state.proposedTiers;
        newObj.filter(x => x.tier === tier)[0][fieldName] = value;
        this.setState({ proposedTiers: newObj });
    }

}




function mapStateToProps({ authentication, companies, configItems }) {
    return {
        authentication,
        ...companies.supCalcSettings,
        configItems,
    };
}

export default compose(
    connect(mapStateToProps, {
        getSupCalcInfo,
        saveSupplementalCalcSettings,
        getConfigItemByParentId,
    })
)(SupCalculatorSettingsPage);
